import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { langType, withLang } from '../../../i18n';
import {
  navigateTo
} from '../../../util';

const ViewParticipantsIconButton = ({
  route, surveyId, translate: t, disabled
}) => {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className="actionButton icon--avatar-group"
      title={t('survey.participants')}
      onClick={() => navigateTo(navigate, route, surveyId)}
      disabled={disabled}
      data-cy="survey-participants-button"
    />
  );
};
const {
  string
} = PropTypes;

ViewParticipantsIconButton.propTypes = {
  surveyId: string.isRequired,
  ...langType
};

export default withLang(ViewParticipantsIconButton);
